import { F } from '@angular/cdk/keycodes';
import { CommonModule } from '@angular/common';
import { HttpClient, HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { APP_INITIALIZER, ModuleWithProviders, NgModule } from '@angular/core';
import { MatButtonLoadingDirective } from './directives/mat-button-loading/mat-button-loading.directive';
import { DivideByPipe } from './pipes/divideBy.pipe';
import { FirstLetterPipe } from './pipes/first-letter.pipe';
import { SafePipe } from './pipes/safe.pipe';
import { AppConfig } from './services/config/app.config';
import { JsonAppConfigService } from './services/config/json-app-config.service';
import { BasicAuthInterceptor } from './services/interceptors/basic-auth.interceptor';
import { ErrorInterceptor } from './services/interceptors/error.interceptor';

function initializerFn(jsonAppConfig: JsonAppConfigService) {
  return () => {
    return jsonAppConfig.load();
  };
}

@NgModule({
  declarations: [
    FirstLetterPipe,
    SafePipe,
    DivideByPipe,
    MatButtonLoadingDirective
  ],
  imports: [CommonModule],
  exports: [
    FirstLetterPipe,
    SafePipe,
    DivideByPipe,
    MatButtonLoadingDirective
  ],
  providers: [
    HttpClientModule,
    { provide: HTTP_INTERCEPTORS, useClass: BasicAuthInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
    {
      provide: AppConfig,
      deps: [HttpClient],
      useExisting: JsonAppConfigService
    },
    {
      provide: APP_INITIALIZER,
      multi: true,
      deps: [JsonAppConfigService],
      useFactory: initializerFn
    }
  ]
})
export class CoreModule { }
